// Roles ride in the JWT's `roles` claim as a comma-separated string. The
// server enforces them; the CMS only reads them to decide what to show.

function payloadOf(token) {
    try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(atob(base64));
    } catch (e) {
        return {};
    }
}

export function rolesFromToken(token) {
    if (!token) return [];
    const raw = payloadOf(token).roles;
    const list = Array.isArray(raw) ? raw : String(raw || '').split(',');
    return list.map(r => r.trim()).filter(Boolean);
}

export const isAdmin = (token) => rolesFromToken(token).includes('admin');
